import React from 'react'
import styled from 'styled-components'
import {PhoneInput} from '@framelink/phone_input'
import {Phone as Icon} from '@mui/icons-material'
import {getDefaultValue, isMobile} from 'utils/utils'
import environment from 'utils/enums/environment'
import flags from 'images/flags.png'


const Link = styled(Icon)`
    font-size: 20px;
    display: flex;
    margin: 0 10px;
    cursor: pointer;
    color: #4a4a4a;
`

class Phone extends React.Component {
    constructor(props) {
        super(props)

        this.phone = React.createRef()
		this.mobile = isMobile()

        this.state = {
            value: props.defaultValue
        }
    }

	componentDidUpdate(props) {
        if (props.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue })
        }
    }

	convertToNumber = (value) => value.replace(/\D/g, '')

	handleBlur = (value, format) => {
        if (this.props.environment) {
            if (this.convertToNumber(value) === this.convertToNumber(format.dialCode)) {
                this.setState({ value: null })
            } else {
                if (this.state.value !== this.props.defaultValue) {
                    this.props.handleUpdate(`${this.state.value ? '+' : ''}` +
                        this.convertToNumber(this.state.value), this.props.name)
                }
            }
        }
    }

    handleChange = (value) => {
        if (!this.props.environment) {
            this.setState({
                value: this.convertToNumber(value)
            }, () => this.props.handleUpdate(`${this.state.value ? '+' : ''}` + this.state.value, this.props.name))
        } else {
            this.setState({ value: this.convertToNumber(value)})
        }
    }

    handleFocus = (value, format) => {
        if (this.props.environment && !this.state.value) {
            const defaultValue = getDefaultValue(this.props.environment, this.props.name, this.props.row)
            if (defaultValue) {
                this.setState({ value: defaultValue }, () => this.phone.current.select())
            } else {
                this.setState({ value: format.dialCode })
            }
        } else if (!this.state.value) {
            this.setState({ value: format.dialCode })
        }
    }


    render() {
		const {config, lookup, readonly} = this.props
		const disabled = this.mobile && this.props.environment === environment.Collection

        return (
			<React.Fragment>
				<PhoneInput
					defaultCountry={config && config.country}
					flagsImagePath={flags}
					value={this.state.value ? this.state.value.toString() : null}
					classNames={(lookup ? 'phoneInput opacity' : 'phoneInput') + (this.state.value ? '' : ' empty')}
					disabled={readonly}
					onBlur={this.handleBlur}
					onFocus={this.handleFocus}
					onChange={this.handleChange}
					inputProps={{ ref: this.phone }}
				/>
				{this.props.environment && this.state.value && !disabled &&
					<a href={'tel:' + this.state.value}><Link /></a>
				}
				{!disabled && !readonly && <div/>}
			</React.Fragment>
        )
    }
}

export default Phone
